import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberFormatModule } from '@prlw/libs/number-format/number-format.module';
import { DynamicInputPlaceholderModule } from '@prlw/libs/dynamic-input-placeholder/dynamic-input-placeholder.module';
import { IconsModule } from '@prlw/libs/icons/icons.module';
import { SyncScrollModule } from '@prlw/libs/sync-scroll/sync-scroll.module';
import { TabsModule } from '@prlw/libs/tabs/tabs.module';
import { NgChartsModule } from 'ng2-charts';
import { DestinationsModule } from '../destinations/destinations.module';
import { ProductsModule } from '../products/products.module';
import { ShipmentsModule } from '../shipments/shipments.module';
import { AllTableTabsModule } from './all-table-tabs/all-table-tabs.module';
import { BasisOverlayTooltipComponent } from './basis-overlay/basis-overlay-tooltip.component';
import { BasisOverlayTooltipDirective } from './basis-overlay/basis-overlay-tooltip.directive';
import { BasisOverlayComponent } from './basis-overlay/basis-overlay.component';
import { BasisOverlayContainer } from './basis-overlay/basis-overlay.container';
import { InstrumentRemoveButtonComponent } from './table-content/instrument-remove-button/instrument-remove-button.component';
import { ManageOverlayComponent } from './manage-overlay/manage-overlay.component';
import { ManageOverlayContainer } from './manage-overlay/manage-overlay.container';
import { ModifiersOverlayComponent } from './modifiers-overlay/modifiers-overlay.component';
import { ModifiersOverlayContainer } from './modifiers-overlay/modifiers-overlay.container';
import { ModifiersComponent } from './modifiers/modifiers.component';
import { ModifiersContainer } from './modifiers/modifiers.container';
import { MonitorRoutingModule } from './monitor-routing.module';
import { MonitorPage } from './monitor.page';
import { ProductSelectionDialogComponent } from './product-selection-dialog/product-selection-dialog.component';
import { ProductSelectionDialogContainer } from './product-selection-dialog/product-selection-dialog.container';
import { TableRowComponent } from './table-content/table-row.component';
import { AllTableTooltipComponent } from './table-tooltip/all-table/all-table-tooltip.component';
import { AllTableTooltipDirective } from './table-tooltip/all-table/table-tooltip.directive';
import { TableTooltipBasisComponent } from './table-tooltip/main-table/table-tooltip-basis.component';
import { TableTooltipComponent } from './table-tooltip/main-table/table-tooltip.component';
import { TableTooltipDirective } from './table-tooltip/main-table/table-tooltip.directive';
import { AllTableComponent } from './table/all-table/all-table.component';
import { AllTableContainer } from './table/all-table/all-table.container';
import { AllTableColumnContentComponent } from './table/all-table/content/column-content.component';
import { AllTableColumnContentContainer } from './table/all-table/content/column-content.container';
import { AllTableColumnHeaderComponent } from './table/all-table/header/column-header.component';
import { AllTableColumnHeaderContainer } from './table/all-table/header/column-header.container';
import { HighlightChangesDirective } from './table/all-table/highlight-changes.directive';
import { LoadingAllTableComponent } from './table/all-table/loading-all-table.component';
import { ShrinkTextOnOverflowDirective } from './table/all-table/shrink-text-on-overflow.directive';
import { ColumnContentComponent } from './table/main-table/column-content/column-content.component';
import { ColumnContentContainer } from './table/main-table/column-content/column-content.container';
import { MainTableHeaderContainer } from './table/main-table/table-header/main-table-header.container';
import { TableComponent } from './table/main-table/table.component';
import { TableContainer } from './table/main-table/table.container';
import { VolumeProgressBarComponent } from './volume-progress-bar/volume-progress-bar.component';
import { VolumeProgressBarContainer } from './volume-progress-bar/volume-progress-bar.container';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LightModeOverlayComponent } from './table/all-table/light-mode-overlay/light-mode-overlay.component';
import AddToAnalyticsButtonComponent from './add-to-analytics-button/add-to-analytics-button.component';
import { StoreModule } from '@ngrx/store';
import {
  analyticsInitialState,
  analyticsReducer,
} from '@legacy/analytics/store/analytics.reducer';
import { BasisDetailsModule } from './table-content/basis-details/basis-details.module';
import { MainTableHeaderComponent } from './table/main-table/table-header/main-table-header.component';
import { DestinationsContainer } from '../destinations/panel/destinations.container';
import { EditTraderTariffComponent } from './table/main-table/edit-trader-tariff/edit-trader-tariff.component';
import { NumberInputComponent } from '../../common/number-input/number-input.component';
import { EditTraderTariffContainer } from './table/main-table/edit-trader-tariff/edit-trader-tariff.container';
import { ResponsiveDirective } from '@prlw/libs/responsive/responsive.directive';
import { BasisBestPriceMobileContainer } from './basis-best-price-mobile/basis-best-price-mobile.container';
import { BasisCounterLabelContainer } from './table/main-table/basis-counter-label/basis-counter-label.container';
import { TextTagOtpComponent } from './text-tag-otp/text-tag-otp.component';
import { TableModule } from '@prlw/common/table/table.module';
import { LicenseCountdownPaneContainer } from '@prlw/common/license-countdown-pane/license-countdown-pane.container';

@NgModule({
  declarations: [
    MonitorPage,
    TableContainer,
    TableComponent,
    AllTableComponent,
    AllTableContainer,
    ColumnContentContainer,
    ColumnContentComponent,
    VolumeProgressBarContainer,
    VolumeProgressBarComponent,
    ManageOverlayContainer,
    ManageOverlayComponent,
    BasisOverlayContainer,
    BasisOverlayComponent,
    BasisOverlayTooltipDirective,
    BasisOverlayTooltipComponent,
    TableTooltipDirective,
    TableTooltipComponent,
    TableTooltipBasisComponent,
    AllTableColumnHeaderComponent,
    AllTableColumnHeaderContainer,
    AllTableColumnContentComponent,
    AllTableColumnContentContainer,
    ModifiersComponent,
    ModifiersContainer,
    AllTableTooltipDirective,
    AllTableTooltipComponent,
    HighlightChangesDirective,
    ShrinkTextOnOverflowDirective,
    LoadingAllTableComponent,
    MainTableHeaderComponent,
    MainTableHeaderContainer,
    TableRowComponent,
    InstrumentRemoveButtonComponent,
    ModifiersOverlayContainer,
    ModifiersOverlayComponent,
    ProductSelectionDialogComponent,
    ProductSelectionDialogContainer,
    LightModeOverlayComponent,
    AddToAnalyticsButtonComponent,
    EditTraderTariffComponent,
    EditTraderTariffContainer,
  ],
  imports: [
    CommonModule,
    MonitorRoutingModule,
    ProductsModule,
    DestinationsModule,
    ShipmentsModule,
    NumberFormatModule,
    IconsModule,
    TableModule,
    AllTableTabsModule,
    ReactiveFormsModule,
    SyncScrollModule,
    TabsModule,
    NgChartsModule,
    FormsModule,
    DynamicInputPlaceholderModule,
    DragDropModule,
    StoreModule.forFeature('analytics', analyticsReducer, {
      initialState: analyticsInitialState,
    }),
    BasisDetailsModule,
    NumberInputComponent,
    ResponsiveDirective,
    BasisBestPriceMobileContainer,
    BasisCounterLabelContainer,
    TextTagOtpComponent,
    LicenseCountdownPaneContainer,
  ],
  providers: [DatePipe],
  exports: [
    DestinationsContainer,
    TableTooltipComponent,
    MainTableHeaderComponent,
    TableRowComponent,
    ColumnContentContainer,
  ],
})
export class MonitorModule {}
